import { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next";
import BookDetail from "./BackStage/BookDetail/BookDetail";
import { Row, Col, Modal } from '../../ui/ot'
import CheckoutsProTableOt from "../components/CheckoutsHistoryProTableOt";
const CheckOutTableModal = ({
    keyPrefix = 'library.bookdetail',
    propsOpen,
    propsSetOpen,
    itemnumber,
    barcode,
    biblionumber,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }
    return (<Row>
        <Col  >
            <Modal
                title
                children
                open={propsOpen === null ? isModalOpen : propsOpen}
                onClose={closeModal}
                closeText="關閉"
                close={true}
                width={1200}
            >
                <Row gutter={[8, 8]}>
                    <Col span={24}>
                    </Col>
                    <Col span={24}>
                        <CheckoutsProTableOt
                            itemnumber={itemnumber}
                            barcode ={barcode}
                            biblionumber ={biblionumber}
                        />
                    </Col>
                </Row>
            </Modal>
        </Col>
    </Row >)
}

export default CheckOutTableModal